var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{attrs:{"group":""}},[_c('b-button',{attrs:{"type":"is-info is-medium","expanded":"","loading":_vm.nappilataa,"label":"Päivitä kohteen tiedote","icon-left":"info"},on:{"click":_vm.lisaaTiedoteModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }